import React from 'react';
import {observer} from 'mobx-react';
import ModelActionLink from './ModelActionLink';
import _ from 'lodash';

const EditLink = observer(({model, action, editModelCaption}) => {
  return (
    <ModelActionLink text={editModelCaption} action={action} model={model}/>
  );
});

const DeleteLink = observer(({model, onRemoveClicked, removeModelCaption}) => {
  return (
    <ModelActionLink text={removeModelCaption} action={onRemoveClicked} model={model}/>
  );
});

const filterCustomLinks = (customLinks, model) => {
  if (_.isFunction(customLinks)) return customLinks(model);

  return customLinks;
};

const ActionLinks = observer(({model, action, onRemoveClicked, editModelCaption, removeModelCaption, customLinks}) => {
  const data = model.data || {};

  customLinks = filterCustomLinks(customLinks, model);

  if (!model.canPatch && !model.canDelete && !data.canPatch && !data.canDelete && _.isEmpty(customLinks)) {
    return null;
  }

  const links = [];

  if ((model.canPatch || data.canPatch) && action) {
    links.push({
      order: 0,
      key: 'edit',
      Component: () => <EditLink model={model} action={action} editModelCaption={editModelCaption}/>
    });
  }

  if ((model.canDelete || data.canDelete) && onRemoveClicked) {
    links.push({
      order: 10,
      key: 'remove',
      Component: () => <DeleteLink model={model} onRemoveClicked={onRemoveClicked} removeModelCaption={removeModelCaption}/>
    });
  }

  links.push(...customLinks
    .map(link => ({
    order: link.order,
    key: link.text,
    Component: () => <ModelActionLink text={link.text} action={link.action} downloadLink={link.downloadLink} model={model}/>
  })));

  return (
    <div onClick={e => e.stopPropagation()} className='action-links'>
      <a href='#' data-toggle='dropdown' className='submarine center'>
        <i className='material-icons'>{'more_horiz'}</i>
      </a>
      <ul className='dropdown-menu'>
        {_.orderBy(links, 'order').map(l => <li key={l.key}><l.Component/></li>)}
      </ul>
    </div>
  );
});

ActionLinks.defaultProps = {
  editModelCaption: 'Edit',
  removeModelCaption: 'Remove',
  customLinks: []
};

export default ActionLinks;
